var _clipPath, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.702.837h48v48h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.655 11.949a3.489 3.489 0 0 0-3.487-3.488H7.362a3.49 3.49 0 0 0-3.488 3.488V39.85a3.49 3.49 0 0 0 3.488 3.488h36.806a3.489 3.489 0 0 0 3.487-3.488V11.949Z",
    style: {
      fill: "#b73c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.53 9.824a3.489 3.489 0 0 0-3.487-3.488H5.237a3.49 3.49 0 0 0-3.488 3.488v27.901a3.49 3.49 0 0 0 3.488 3.488h36.806a3.489 3.489 0 0 0 3.487-3.488V9.824Z",
    style: {
      fill: "#4ecd6a"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.53 9.824a3.489 3.489 0 0 0-3.487-3.488H5.237a3.49 3.49 0 0 0-3.488 3.488v27.901a3.49 3.49 0 0 0 3.488 3.488h36.806a3.489 3.489 0 0 0 3.487-3.488V9.824Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.685 17.574h-6.779c-.587 0-1.063.475-1.063 1.062v10.277c0 .587.476 1.063 1.063 1.063h6.779v-1.063h-6.779V18.636h6.779v-1.062ZM2.69 17.574v1.062h6.684v10.277H2.69v1.063h6.684c.587 0 1.062-.476 1.062-1.063V18.636c0-.587-.475-1.062-1.062-1.062H2.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.64,
    cy: 24.064,
    r: 6.375,
    style: {
      fill: "#4ecd6a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.64 17.158a6.91 6.91 0 0 0-6.907 6.906 6.91 6.91 0 0 0 6.907 6.907 6.91 6.91 0 0 0 6.906-6.907 6.91 6.91 0 0 0-6.906-6.906Zm0 1.062a5.847 5.847 0 0 1 5.844 5.844 5.847 5.847 0 0 1-5.844 5.844 5.846 5.846 0 0 1-5.844-5.844 5.847 5.847 0 0 1 5.844-5.844Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.108 7.353v33.422a.532.532 0 1 0 1.063 0V7.353a.531.531 0 0 0-1.063 0Z",
    style: {
      fill: "#fff"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.53 9.824a3.489 3.489 0 0 0-3.487-3.488H5.237a3.49 3.49 0 0 0-3.488 3.488v27.901a3.49 3.49 0 0 0 3.488 3.488h36.806a3.489 3.489 0 0 0 3.487-3.488V9.824Zm-1 0v27.901a2.489 2.489 0 0 1-2.487 2.488H5.237a2.49 2.49 0 0 1-2.488-2.488V9.824a2.49 2.49 0 0 1 2.488-2.488h36.806a2.489 2.489 0 0 1 2.487 2.488Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPitch);
export default __webpack_public_path__ + "static/media/pitch.3360fe82847386f84818c0c42a28589a.svg";
export { ForwardRef as ReactComponent };